/*
 * @Author: Nora Galvin
 * @Date: 2020-08-21 08:51:35
 * @Last Modified by: Nora
 * @Last Modified time: 2020-09-04 16:13:17
 */
import template from './template.html';
import type { TypeInputEmitData } from '@/app/editor/sidebar/interactions/animations/type';

/**
 * DropdownControl
 */
export default class DropdownControl {
  _$input: JQuery;
  _$interactionTab: JQuery;
  _$interactionPanel: JQuery;
  _options: any;

  /**
   * constructor
   * @param $input ..
   * @param options ..
   */
  constructor($input: JQuery, options?: any) {
    this._$input = $input;
    this._$interactionTab = jQuery('.simple-tabs');
    this._$interactionPanel = this._$interactionTab.find('.interactions-panel');
    this._options = options;
    this.renderTemplate();
  }

  /**
   * Render Select to Template
   * @returns void
   */
  renderTemplate(): void {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const _this = this;

    this._$input.hide();
    const options = this._$input.find('option');
    const html = template(options);

    const $html = $(html);

    $html.find('.gf-dropdown-list').addClass('!overflow-auto');
    // Toggle click dropdown select animations
    $html.off('click').on('click', function (_event) {
      // Close all other dropdown
      _this._$interactionPanel.find('.gf-dropdown-list').not($(this).find('.gf-dropdown-list')).hide();
      $(this).find('.gf-dropdown-list').toggle();
      const visible = $(this).find('.gf-dropdown-list').is(':visible');
      if (visible) {
        if (_this._options && _this._options.onOpened) {
          _this._options.onOpened();
        }
      } else {
        if (_this._options && _this._options.onClosed) {
          _this._options.onClosed();
        }
      }
    });

    // Click outside
    jQuery(window).click(function (event) {
      if (!($(event.target).parents('.gf-dropdown').is('.gf-dropdown') || $(event.target).is('.gf-dropdown'))) {
        _this._$interactionPanel.find('.gf-dropdown-list').hide();
        if (_this._options && _this._options.onClosed) {
          _this._options.onClosed();
        }
      }
    });

    $html
      .find('.gf-dropdown-item')
      .off('click')
      .on('click', function (_event) {
        const key = $(this).data('key') || '';
        const value = $(this).data('value') || '';
        const inputType = _this._$input.data('inputtype') || '';
        const configType = _this._$input.data('key') || '';

        const data: TypeInputEmitData = {
          key: key,
          value: value,
          inputType: inputType,
          type: configType,
        };

        _this.setValue(key);

        if (_this._options && _this._options.onChange) {
          _this._options.onChange(data);
        }
      });

    ($html.find('.gf-dropdown-list').addClass('optiscroll') as any).optiscroll();

    this._$input.after($html);
  }

  /**
   * Set value to select
   * @param val ..
   * @returns void
   */
  setValue(val: string | number): void {
    this._$input.val(val);
    this._$input.next('.gf-dropdown').find('.gf-dropdown-selected p').text(this._$input.find('option:selected').text());
    // Clear default then set again
    this._$input.next('.gf-dropdown').find('.gf-dropdown-item').removeClass('gf-dropdown-item-selected');
    this._$input.next('.gf-dropdown').find(`.gf-dropdown-item[data-key=${val}]`).addClass('gf-dropdown-item-selected');
  }
}
